import * as types from './mutations-types'
import pointsMailApi from '../../../../../api/wx-member/points-mall/points-mall'
import FormatTableFieldUtils from '../../../../../common/utils/format-table-field-util'
import * as DictConstants from '../../../../../constants/DictConstants'
import * as DataTypeConstants from '../../../../../constants/DataTypeConstants'

export default {
  getMemberPointsChangeLogPageList: ({ commit }, data) => {
    pointsMailApi.getMemberPointsChangeLogPageList(data).then(result => {
      let params = [
        {
          fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
          fieldPropCode: 'pointsChangeType',
          fieldPropName: 'changeTypeName',
          fieldFormatParam:
            DictConstants.TYPE_PMALL_MEMBER_POINTS_CHANGE_LOG_TYPE
        }
      ]
      FormatTableFieldUtils.formatTableFieldName(result.dataList, params).then(
        res => {
          result.dataList = res
          commit(types.MY_POINTS_LIST, result)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-points/store/actions.js